import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  message?: string;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, message: error instanceof Error ? error.message : undefined };
  }

  componentDidCatch(error: unknown, info: unknown) {
    console.error('Unbehandelter Render-Fehler:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="max-w-md w-full rounded-lg border-2 border-destructive/30 bg-card/80 backdrop-blur-sm p-6 text-center space-y-4">
          <AlertTriangle className="w-10 h-10 text-destructive mx-auto" aria-hidden="true" />
          <h1 className="text-xl font-bold">Es ist ein Fehler aufgetreten</h1>
          <p className="text-sm text-muted-foreground">
            Die Highscore-Anzeige konnte nicht dargestellt werden. Bitte lade die Seite neu.
          </p>
          {this.state.message && (
            <p className="text-xs text-muted-foreground break-words">{this.state.message}</p>
          )}
          <Button onClick={() => window.location.reload()}>Seite neu laden</Button>
        </div>
      </div>
    );
  }
}
